export var EVENTS = {
  APP_CURRENTLY_NOT_AVAILABLE: 'This app is currently not available.'
};